import { WindowLocation } from '@gatsbyjs/reach-router'
import { createContext } from 'react'

export interface LocationContextValue {
  location: WindowLocation | null
  setLocation: (location: WindowLocation) => void
}

export const LocationContext = createContext<LocationContextValue>({
  location: null,
  setLocation: () => {
    // noop
  },
})

// Build-time page `path` from Gatsby PageProps; available during SSG, unlike `useLocation()`.
export const PagePathContext = createContext<string | null>(null)
